import "./NavbarFooter.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="custom-footer text-white pt-3 pb-3">
      <div className="container">

        {/* Title */}
        <div className="text-center mb-3">
          {/* <p className="small mb-0">
            The Temple Directory • Explore spiritual places with ease
          </p> */}
        </div>

        {/* Footer Sections */}
        <div className="row text-center">

          {/* Quick Links */}
          <div className="col-md-4 mb-1 small">
            <h6 className="fw-semibold mb-2">Quick Links</h6>

            <Link to="/" className="footer-link d-block">
              Home
            </Link>

            <Link to="/temples" className="footer-link d-block">
              Temple List
            </Link>

            <Link to="/plan" className="footer-link d-block">
              Plan Visit
            </Link>

            <Link to="/gallery" className="footer-link d-block">
              Gallery
            </Link>

            <Link to="/faq" className="footer-link d-block">
              FAQ
            </Link>

            <Link to="/about" className="footer-link d-block">
              About us
            </Link>
          </div>

          {/* Contact */}
          <div className="col-md-4 mb-3">
            {/* <h6 className="fw-semibold mb-2">Project Team</h6> */}

            <h6 className="mb-1 small">
              Developed by
            </h6>

            <p className="mb-1 small">
              Sanmati Engineering College, Washim
            </p>
            {/* <p className="mb-1 small">
              miss.nisarga,mr.ganesh,miss.aditi
            </p>

            <p className="mb-1 small">
              Temple Information & Directory System
            </p> */}

            <p className="mb-0 small">
              Maharashtra, India
            </p>
          </div>

          {/* Languages */}
          <div className="col-md-4 mb-3">
            <h6 className="fw-semibold mb-2">Languages</h6>

            <p className="mb-1 small">English</p>
            <p className="mb-1 small">Hindi</p>
            <p className="mb-2 small">Marathi</p>

            <h6 className="fw-semibold mt-2 mb-1">Services</h6>

            <p className="mb-1 small">
              Temple Search
            </p>

            <p className="mb-0 small">
              Spiritual Information
            </p>
          </div>

        </div>

        {/* Bottom */}
        <div className="text-center pt-2 border-top border-white">
          <p className="small mb-0">
            © 2026 DARSHANIKA | All Rights Reserved
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;